import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';

import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { ReserveDetailPanelController } from './ReserveDetailPanelController';
import {PopoverAlertComponent} from '../../../../../Common/Popover/Alert/PopoverAlertComponent';

import {ReservationDTOInterface} from '../../../../../../DTO/ReservationDTOInterface';
import {MstClinicDTOInterface} from '../../../../../../DTO/MstClinicDTOInterface';
import {MstDepartmentDTOInterface} from '../../../../../../DTO/MstDepartmentDTOInterface';

// @ts-ignore
import * as cloneDeep from 'clone-deep';
import {MstExaminationDTOInterface} from '../../../../../../DTO/MstExaminationDTOInterface';
import {UserDTOInterface} from '../../../../../../DTO/UserDTOInterface';
import {ReservationInterviewDTOInterface} from '../../../../../../DTO/ReservationInterviewDTOInterface';

/**
 * ReserveDetailPanelComponent
 * 予約詳細画面
 */
@Component({
	selector: 'ReserveDetailPanelComponent',
	templateUrl: './ReserveDetailPanelComponent.html',
	styleUrls: ['../Reserve.scss', './ReserveDetailPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class ReserveDetailPanelComponent extends BasePanelSlide {

	// コンポーネントを操作するコントローラー
	public combineCtrl: ReserveDetailPanelController;
	// 自分自身のコンポーネント名称
	public componentName = 'ReserveDetailPanelComponent';

	// 終了を親に通知する処理。親でセット
	public eventClose: any;

	// 予約ID
	public reserveId: number;
	public reserveDetail: any;

	public reserve: ReservationDTOInterface = {} as ReservationDTOInterface;
	public clinic: MstClinicDTOInterface = {} as MstClinicDTOInterface;
	public department: MstDepartmentDTOInterface = {} as MstDepartmentDTOInterface;
	public examinationList: Array<MstExaminationDTOInterface> = [] as Array<MstExaminationDTOInterface>;
	public user: UserDTOInterface = {} as UserDTOInterface;

	// 編集するターゲットデータ。呼び出し元でセットする。これは、変更しない。
	public targetData: any;

	// 更新画面表示
	public eventShowUpdateView: (reservationId: number) => boolean;

	// キャンセル処理が可能か
	public isCancel = true;
	// 更新処理が可能か
	public isUpdate = true;
	// 予約当日か
	public isToday = false;

	public interviewList: Array<ReservationInterviewDTOInterface> = [];
	/**
	 * constructor
	 * @param dialogCtrl
	 */
	constructor(
		public dialogCtrl: MatDialog, // ダイアログ機能
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();
		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(ReserveDetailPanelController);
	}


	/**
	 * start
	 * 開始処理
	 */
	public async start() {
		this.log('ReserveDetailPanelComponent::start()');
		const data = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getReserveDetailViewData.bind(this),
			{view: this, reserveId: this.reserveId}
		);
		this.log(data);

		this.reserveDetail = data.reservation;
		this.reserve = this.reserveDetail.reservation;
		this.clinic = this.reserveDetail.mstClinic;
		this.department = this.reserveDetail.mstDepartment;
		this.examinationList = this.reserveDetail.mstExamination;
		this.user = this.reserveDetail.user;
		this.interviewList = this.reserveDetail.interview;

		// 更新、キャンセルの可否設定
		if (this.reserve.status === 'CANCEL') {
			// キャンセル済みの予約の場合、更新不可
			this.isUpdate = false;
			this.isCancel = false;
		} else {
			// アクティブな予約の場合、期限に応じて変更、キャンセルができる
			// 現在
			const now = new Date();

			// アクセス日時が予約当日かチェック
			const reserveDate = new Date(this.reserve.reservationDate);
			if (now.toDateString() === reserveDate.toDateString()) {
				this.isToday = true;
			}

			// 更新可能かチェック
			const updateDeadline = new Date(data.updateDeadline);
			if (now > updateDeadline) {
				this.isUpdate = false;
			}

			// キャンセル可能かチェック
			const cancelDeadline = new Date(data.cancelDeadline);
			if (now > cancelDeadline) {
				this.isCancel = false;
			}
		}

		// スライドイン表示は自分でやる
		await this.slideIn();

	}

	/**
	 * onClickClosePanel
	 * パネルを閉じたときの処理
	 */
	 public async onClickClosePanel() {

		await this.eventClose();

	}

	/**
	 * 予約変更画面の表示
	 */
	public async onClickChangeReservation(): Promise<void> {
		 await this.eventShowUpdateView(this.reserve.id);
	}

	/**
	 * キャンセルダイアログの表示
	 */
	public async onClickCancelReservation() {

		await this.showDialogWindow(
			PopoverAlertComponent,
			{
				title: '予約キャンセル',
				text: 'この予約をキャンセルしてもよいですか',
				close: this.execCancelReservation.bind(this)
			}
		);

	}

	/**
	 * キャンセル実行
	 * @param isCancel
	 */
	public async execCancelReservation(isCancel: boolean) {

		await this.dismissDialogWindow();

		if (isCancel) {
			const ret = await this.execFuncWithErrorHandling(
				this,
				this.combineCtrl.cancelReservation.bind(this),
				{view: this, data: this.reserve}
			);

			if (!ret) {
				return;
			}

			// キャンセルメッセージの送信処理
			const sendMessage = await this.execFuncWithErrorHandling(
				this,
				this.combineCtrl.sendReserveCancelMessage.bind(this),
				{view: this, reserveId: this.reserve.id}
			);

			await this.eventClose();
		}

	}
}
